import React from "react";
import ChatHistory from "../../../../components/Chat/ChatHistory";

const ChatList = () => {
  return (
    <div className="flex-1 h-full flex flex-col ">
      <ChatHistory />
    </div>
  );
};

export default ChatList;
